module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-bar",
    class: _vm.menuClass
  }, [_c('button', {
    staticClass: "menu-bar__hamburger",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "hamburger hamburger--elastic",
    class: _vm.hamburgerClass
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "menu-bar__title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "menu-bar__menu"
  }, [_vm._t("categories")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hamburger-box"
  }, [_c('div', {
    staticClass: "hamburger-inner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c09d03c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuBar.vue
// module id = 112
// module chunks = 0